/* Great Lakes Lavender Farm — journey events v1 (Lavender Grower 0.6.3).
   Listens to the order builder's own events (it is not changed) and reports each step to the store's analytics,
   so the farm's journey timeline shows the builder steps, ship date, season, protection quote, deposit and the
   moments the builder stops someone (state rules, summer pickup, minimums, dates). Nothing about the shopper's
   address, ZIP or city is sent. Only runs where the store's analytics run (respects the visitor's choices). */
(function () {
  "use strict";
  if (window.__gllfJourneyEvents) return;
  window.__gllfJourneyEvents = true;

  var lastState = null, lastProtection = null, lastBlocked = "", lastStep = "";
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") Shopify.analytics.publish(name, data); } catch (e) { /* never break the store */ }
  }
  function productInfo(target) {
    var root = target && target.closest ? target.closest("[data-product-id]") : null;
    var title = (root && root.dataset && root.dataset.productTitle) || document.querySelector('meta[property="og:title"]') && document.querySelector('meta[property="og:title"]').getAttribute("content") || document.title;
    var handle = (location.pathname.match(/\/products\/([a-z0-9-]+)/i) || [])[1] || "";
    return { title: String(title || "").slice(0, 160), handle: handle };
  }
  function seasonOf(ymd) {
    var m = Number(String(ymd || "").slice(5, 7));
    if (!m) return "";
    if (m >= 6 && m <= 9) return "summer";
    if (m >= 3 && m <= 5) return "spring";
    if (m >= 10 && m <= 11) return "fall";
    return "winter";
  }
  function cents(v) { var n = Number(v); return isFinite(n) && n > 0 ? Math.round(n) : null; }
  function protectionCents() {
    var p = lastProtection;
    if (!p) return null;
    var s = p.shipping || {}, g = p.grow || {};
    var picked = (s.selected ? cents(s.amountCents) || 0 : 0) + (g.selected ? cents(g.amountCents) || 0 : 0);
    return picked || cents(s.amountCents) || cents(g.amountCents);
  }
  function depositPct(state) {
    var mode = state && state.order && state.order.mode || "";
    return /deposit/i.test(mode) ? 50 : null;
  }
  // Order builder stop reasons → the farm's plain reasons (the code is kept after the colon).
  function reasonOf(codes) {
    var c = (codes || []).join(" ").toUpperCase();
    if (!c) return "";
    var r = /NO_SHIP_STATE|SOIL|RESTRICTED_STATE|STATE_RULE/.test(c) ? "soil_state"
      : /SUMMER|BEETLE|HEAT|PICKUP_ONLY/.test(c) ? "summer_pickup"
      : /MINIMUM|MOQ|CASE_QTY|BELOW_MIN/.test(c) ? "wholesale_min"
      : /DATE|WINDOW|WEATHER|SEASON|LEAD_TIME|TOO_SOON|TOO_EARLY/.test(c) ? "ship_date"
      : /PO_BOX|POBOX/.test(c) ? "po_box"
      : /SOLD|STOCK|INVENTORY|UNAVAILABLE/.test(c) ? "sold_out" : "other";
    return (r + ":" + c).slice(0, 60);
  }
  var PLAIN = { soil_state: "plants in soil can't ship to this state (bare root can)", summer_pickup: "summer plants are pickup only", wholesale_min: "below the wholesale minimum", ship_date: "the requested date isn't available", po_box: "plants can't ship to a PO box", sold_out: "not available right now" };
  // 0.7.2: the exact stop, so different causes are never lumped together as "the date isn't available".
  var CODE_PLAIN = {
    REQUESTED_DATE_REQUIRED: "pressed Continue without a date that works", SAFER_WINDOW_REQUESTED: "weather asked for a safer date",
    HISTORICAL_WINDOW_CHOICE_REQUIRED: "had to choose a safer weather window", WEATHER_COVERAGE_UNAVAILABLE: "no weather coverage for that date",
    PICKUP_DATE_NOT_APPROVED: "that pickup day isn't open", PICKUP_WINDOW_INVALID: "that pickup day isn't open",
    DESTINATION_NOT_VERIFIED: "pressed Continue before checking the ZIP", GROWING_PLAN_REQUIRED: "pressed Continue without picking where it will grow",
    BUYER_MODE_REQUIRED: "pressed Continue without picking retail or wholesale", PROTECTION_NOT_SETTLED: "protection prices were still loading",
  };
  function plain(reason, code) { var c = String(code || "").toUpperCase(); if (CODE_PLAIN[c]) return CODE_PLAIN[c]; var k = String(reason || "").split(":")[0]; return PLAIN[k] || c.toLowerCase().replace(/_/g, " "); }
  // Codes that only mean "still loading" are never a stop.
  var PASSING = /^(WEATHER_PENDING|HISTORICAL_REVIEW_PENDING|FULL_ADDRESS_PENDING|OTHER_STATE_RULES_PENDING|INSPECTION_PENDING|STANDARD_STATE_REVIEW)$/;
  function shownError(target) { try { var root = target && target.closest ? target.closest("[data-product-id]") || document : document; var el = root.querySelector("[data-purchase-error]:not([hidden]), .gllf-purchase-error:not([hidden])"); return el ? String(el.textContent || "").replace(/\s+/g, " ").replace(/Ask the farm.*$/, "").trim().slice(0, 160) : ""; } catch (e) { return ""; } }
  function base(detail) {
    var st = lastState || {};
    var date = st.dates && st.dates.requestedShipDate || "";
    return {
      kind: [detail && detail.intent || "retail", detail && detail.fulfillment || ""].filter(Boolean).join(" ").slice(0, 30),
      shipDate: String(date).slice(0, 10), season: seasonOf(date),
      protectionCents: protectionCents(), depositPct: depositPct(st),
      state: st.destination && st.destination.state ? String(st.destination.state).slice(0, 4) : null,
    };
  }
  var STEP_NAMES = {
    journey_started: "Started the order builder", step_viewed: "Order builder step", fulfillment_selected: "Picked shipping or pickup",
    date_selected: "Picked a date", growing_plan_selected: "Picked a growing plan", substitution_preference_selected: "Picked a substitution choice",
    order_ready: "Order ready", add_to_cart_started: "Adding to cart", add_to_cart_succeeded: "Added to cart",
    request_saved: "Saved the request", wholesale_review_add_started: "Adding to wholesale basket", wholesale_review_added: "Added to wholesale basket",
    saved_plan_created: "Saved a delivery plan", saved_plan_applied: "Used a saved delivery plan", historical_weather_fallback: "Used historical weather",
    journey_abandoned: "Left the order builder",
  };
  document.addEventListener("gllf:shipping-change", function (e) { lastState = e.detail && e.detail.state || lastState;
    var st = lastState;
    if (st && st.order && st.order.allowed === false) {
      var codes = (st.order.reasonCodes || []).filter(function (c) { return !PASSING.test(String(c)); });
      var key = codes.join(",");
      if (key && key !== lastBlocked && reasonOf(codes).indexOf("other:") !== 0) {
        lastBlocked = key;
        var p = productInfo(e.target), b = base(null);
        publish("gllf_builder_blocked", Object.assign(b, { handle: p.handle, title: p.title, reason: reasonOf(codes), message: plain(reasonOf(codes), codes[0]) }));
      }
    } else lastBlocked = "";
  }, true);
  document.addEventListener("gllf:protection-state", function (e) { lastProtection = e.detail || lastProtection; }, true);
  document.addEventListener("gllf:buying-journey-event", function (e) {
    var d = e.detail || {};
    var name = String(d.event || "");
    var p = productInfo(e.target), b = base(d);
    if (name === "step_error" || name === "guidance_shown") {
      var code = d.reason || d.supportCode || "";
      var target = e.target, step = d.errorStep || d.step || "";
      // Read the words the shopper actually saw, a moment after they appear.
      setTimeout(function () {
        var saw = shownError(target);
        publish("gllf_builder_blocked", Object.assign(b, { handle: p.handle, title: p.title, step: Number(step) || null, code: String(code).slice(0, 60), reason: reasonOf([code]) || "other:" + String(code).slice(0, 40), message: ("step " + step + ": " + plain(reasonOf([code]), code) + (saw ? " — “" + saw + "”" : "")).slice(0, 200) }));
      }, 60);
      return;
    }
    if (!STEP_NAMES[name]) return;
    var sig = name + ":" + (d.step || "") + ":" + b.shipDate + ":" + (b.protectionCents || "");
    if (sig === lastStep) return;
    lastStep = sig;
    publish("gllf_builder_step", Object.assign(b, { handle: p.handle, title: p.title, variantId: String(d.variantId || "").slice(0, 40), step: Number(d.step) || null, stepName: STEP_NAMES[name] + (name === "step_viewed" && d.step ? " " + d.step : "") }));
  }, true);
})();
